// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"TableManagement_mainContainer_NmjG5","buttonsContainer":"TableManagement_buttonsContainer_2g2nY"};